import styled, {css, DefaultTheme} from 'styled-components'
import {TableBodyCell, TableBodyCellText} from '@components/ui/table-atoms/TableAtoms.tsx'
import {Access} from '@/features/accesses/types'

export const StyledWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto auto minmax(0, 1fr);
        height: 100%;
        background-color: ${palette.neutral['white']};
        border: 1px solid ${palette.neutral[200]};
        border-top: none;
    `
)

export const StyledSelectCell = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: ${spacing * 2}px;
        width: 100%;
        padding: ${spacing * 0.5}px;
    `
)

export const StyledStatusCell = styled(TableBodyCellText)(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        width: 100%;
    `
)

export const StyledOperatorCell = styled(TableBodyCell)(
    ({theme: {typography}}) => css`
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        & > p:last-child {
            ${typography.textXs}
        }
    `
)

const getStatusColor = (status1: Access['status'], palette: DefaultTheme['palette']) => {
    const statusToColors = {
        validated: palette.success['500'],
        to_validate: palette.red['500'],
        excluded: palette.neutral['500'],
        accounted: palette.primary['500']
    } as const satisfies Record<Access['status'], string>

    return statusToColors[status1]
}

export const StyledColorSquare = styled.div<{$status: Access['status']}>(
    ({theme: {palette, opacities}, $status}) => css`
        width: 8px;
        height: 8px;
        border-radius: 2px;
        display: inline-block;
        border: 1px solid ${palette.neutral.black}${opacities['10']};
        background-color: ${getStatusColor($status, palette)};
    `
)
